import { Controller } from "@hotwired/stimulus"

// Controls the card/table view toggle for the repository page
// Stores preference in localStorage
export default class extends Controller {
  static targets = ["cardView", "tableView", "cardBtn", "tableBtn"]

  connect() {
    // Check localStorage for saved preference, default to card view on mobile
    const savedView = localStorage.getItem('repositoryViewMode')
    const isMobile = window.innerWidth < 768 // md breakpoint

    // On mobile, always show cards (toggle buttons are hidden)
    if (isMobile) {
      this.showCards(false) // Don't save to localStorage
      return
    }

    // On larger screens, respect saved preference
    if (savedView === 'table') {
      this.showTable()
    } else if (savedView === 'cards') {
      this.showCards()
    } else {
      // Default: table on desktop
      this.showTable()
    }

    // Listen for resize to handle orientation changes
    this.handleResize = this.handleResize.bind(this)
    window.addEventListener('resize', this.handleResize)
  }

  disconnect() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize() {
    const isMobile = window.innerWidth < 768
    if (isMobile) {
      // Force cards on mobile
      this.showCards(false)
    }
  }

  showCards(savePreference = true) {
    this.cardViewTarget.classList.remove('hidden')
    this.tableViewTarget.classList.add('hidden')

    // Update button styles (only if buttons exist - they're hidden on mobile)
    if (this.hasCardBtnTarget && this.hasTableBtnTarget) {
      this.cardBtnTarget.classList.add('bg-blue-100', 'text-blue-700', 'border-blue-300')
      this.cardBtnTarget.classList.remove('bg-white', 'text-gray-700')
      this.tableBtnTarget.classList.remove('bg-blue-100', 'text-blue-700', 'border-blue-300')
      this.tableBtnTarget.classList.add('bg-white', 'text-gray-700')
    }

    if (savePreference) {
      localStorage.setItem('repositoryViewMode', 'cards')
    }
  }

  showTable() {
    this.tableViewTarget.classList.remove('hidden')
    this.cardViewTarget.classList.add('hidden')

    // Update button styles (only if buttons exist)
    if (this.hasCardBtnTarget && this.hasTableBtnTarget) {
      this.tableBtnTarget.classList.add('bg-blue-100', 'text-blue-700', 'border-blue-300')
      this.tableBtnTarget.classList.remove('bg-white', 'text-gray-700')
      this.cardBtnTarget.classList.remove('bg-blue-100', 'text-blue-700', 'border-blue-300')
      this.cardBtnTarget.classList.add('bg-white', 'text-gray-700')
    }

    localStorage.setItem('repositoryViewMode', 'table')
  }
}
